import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotList from './components/HotList';
import LatestUpdate from './components/LatestUpdate';
import NewsletterSection from './components/NewsletterSection';
import FAQSection from './components/FAQSection';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function Home() {
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '福利视频网址大全·最新免费高清资源入口',
    description: '汇聚全网最新福利视频网址，提供免费高清视频资源导航，每日更新可用地址，告别失效链接烦恼。',
    url: '',
    mainEntity: {
      '@type': 'ItemList',
      name: '热门视频资源推荐',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '2026年最新热门综艺合集', url: '/article/1' },
        { '@type': 'ListItem', position: 2, name: '暑期档必看电影推荐', url: '/article/2' },
        { '@type': 'ListItem', position: 3, name: '经典国产电视剧全集', url: '/article/3' },
      ],
    },
  };

  return (
    <>
      <SchemaOrg data={webPageSchema} />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HotList />
        <LatestUpdate />
        <NewsletterSection />
        <FAQSection />
      </main>
    </>
  );
}